import React,{Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ReplayIcon from '@material-ui/icons/Replay';
import CropFreeIcon from '@material-ui/icons/CropFree';
import StaticPageBody from './StaticPage/StaticPageBody'
import NotFinishedPageWrapper from '../FunctionArea/NotFinishedPageWrapper'
import {server_ip} from '../../ipAddress'
  
  const useStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      //padding: theme.spacing(1),
    },
    paper: {
      //padding: theme.spacing(1),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },

    rowPaper: {
      //padding: theme.spacing(1),
      display: 'block',
      overflow: 'auto',
    },
    textLink:{
      //height:30,
      width:"90%",
      color:"white",
      fontFamily:"Microsoft JhengHei",
      borderStyle:"soild",
      borderWidth:1,
      borderColor:"black",
      backgroundColor:"#2783c4",
      textAlign:"center",
      fontSize:15,
      lineHeight:"30px",
      margin:5,
      '&:hover':{
          color:"black",
          cursor:"pointer"
      }  
    },

    modeTextLink:{
      width:"90%",
      color:"white",
      fontFamily:"Microsoft JhengHei",
      borderStyle:"soild",
      borderWidth:1,
      borderColor:"black",
      textAlign:"center",
      fontSize:15,
      lineHeight:"30px",
      margin:5,
      '&:hover':{
          color:"black",
          cursor:"pointer"
      }  
    },

    fixedHeight: {
      height: '85vh',
    },
    button: {
      margin:theme.spacing(1),
      //padding: theme.spacing(1),
      fontFamily:'Microsoft JhengHei',
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    rightIcon: {
      marginLeft: theme.spacing(1),
    },
    iconSmall: {
      fontSize: 20,
    },
    sessionInfo:{
      width:'640px',
      fontSize: 20,
      fontFamily: "Microsoft JhengHei",
      backgroundColor:"red",
      color:"white",
      border:"1px solid",
      borderRadius:"5px",
      padding:"0px 10px 0px 10px",
      margin:"5px"
    }
  });

  class StaticPageManagementBody extends Component {
    constructor(props) {
      super(props)
      this.state = {
        switchMode:1,
        sessionInfo:null,
        showNotFinishedWrapper:false
      }
      this.staticPageBodyRef = React.createRef()
    }

    componentDidMount(){
      if(this.props.userID)
      {
        this.sessionCheck()
      }
      this.props.getCurrentModule("StaticPageManagement")
      
      window.addEventListener("beforeunload",(e)=>{ 
        e.preventDefault()    
        return this.freeStaticPageSession()
      })
    }

    componentWillUnmount(){
      window.removeEventListener("beforeunload", this.freeStaticPageSession())
    }

    sessionCheck=async()=>{
      let result = await this.checkSessionResult(this.props.userID)
      if(result.sessionAvaliable)
      {
          console.log('StaticPage Session free')
          this.setStaticPageSession(this.props.userID)
      }
      else
      {
          console.log('StaticPage Session occupied')
      }

      this.setState({
          sessionInfo:result                                                                             
      })
    }

    checkSessionResult=async(userID)=>{
      let msg = await fetch(server_ip+'/api/staticPage/check/StaticPageSession')
      let output = await msg.json()
      console.log(output[0])
      if(output[0].StaticPageSession === 0)
      {
          return {sessionAvaliable:true,sessionOccupier:null}
      }
      else
      {
          if(output[0].UserID === userID)
          {
              return {sessionAvaliable:true,sessionOccupier:null}
          }
          else
          {
              return {sessionAvaliable:false,sessionOccupier:output[0].UserName}
          }
      }
    }

    freeStaticPageSession=async()=>{
      console.log('freeStaticPageSession')
      if(this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable)
      {
          let msg = await fetch(server_ip+'/api/staticPage/free/StaticPageSession',{
              method:'PUT',
              headers:{
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
          })
          //let output = await msg.json()
          console.log(msg.status)
      }      
    }

    setStaticPageSession=async(userID)=>{
      let tempBody = {
          'UserID':userID
      }
      
      let msg = await fetch(server_ip+'/api/staticPage/set/StaticPageSession',{
          method:'PUT',
          headers:{
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body:this.getEncodeFormBody(tempBody)
      })
      let output = await msg.json()
      console.log(output[0])
    }

    getEncodeFormBody=(formObject)=>{
      let formBody =[]
      for (let property in formObject) 
      {
          let encodedKey = encodeURIComponent(property);
          let encodedValue = encodeURIComponent(formObject[property]);
          formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");
      return formBody
    }

    switchMode=(msg)=>{
      if(this.state.switchMode !== msg)
      {
        this.setState({
          switchMode : msg
        })
      }
    }

    editPage=(msg)=>{
      this.props.history.push("/StaticPageManagement/StaticPageID/"+msg.id)
    }

    publicTemp=()=>{
      this.staticPageBodyRef.current.publicStaticPage()
    }

    showSessionInfoArea=()=>{
      const {classes} = this.props;
      if(this.state.sessionInfo && !this.state.sessionInfo.sessionAvaliable)
      {
        return <div className={classes.sessionInfo}>靜態頁面 <span style={{backgroundColor:"blue",color:"white"}}>{this.state.sessionInfo.sessionOccupier}</span>正在編輯，目前僅能檢視，所做任何變更均不會儲存</div>
      }
      else
      {
        return null
      }
    }

    showButtonArea=()=>{
      if(this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable)
      {
        const {classes} = this.props
        let leftTopCornerIconAreaStyle={
          float: "left",
          display: "flex",
          width: "30%"
        }
        return  (
          <div style={leftTopCornerIconAreaStyle}>
            <Button className={classes.modeTextLink} style={this.state.switchMode === 1 ? {color:"#000000", backgroundColor:"#ffe736"} : {backgroundColor:"#2783c4"}}   startIcon={<BorderColorIcon/>} onClick={()=>this.switchMode(1)}>
              {'編輯中頁面'}
            </Button>
            <Button className={classes.modeTextLink} style={this.state.switchMode === 2 ? {color:"#000000",backgroundColor:"#ffe736"} : {backgroundColor:"#2783c4"}} startIcon={<LibraryBooksIcon/>} onClick={()=>this.switchMode(2)}>
              {'目前發佈頁面'}
            </Button>
          </div>
        )
      }
      else
      {
        return null
      }
    }


    render(){
      const {classes} = this.props
      // let leftTopCornerIconAreaStyle={
      //   float: "left",
      //   display: "flex",
      //   width: "30%"
      // }

      let rightTopCornerIconAreaStyle={
        float: "right",
        display: "flex",
        width: "40%"
      }

    return (

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {this.state.showNotFinishedWrapper?<NotFinishedPageWrapper closeModal={()=>this.setState({showNotFinishedWrapper:false})}/>:null}
          <Container maxWidth={false} className={classes.container}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Paper className={classes.rowPaper}>
                  {this.showSessionInfoArea()}
                  {this.showButtonArea()}
                  {
                    this.state.switchMode === 1 && this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable ?
                    <div style={rightTopCornerIconAreaStyle}>
                      <Button className={classes.textLink} startIcon={<CropFreeIcon/>} onClick={()=>this.setState({showNotFinishedWrapper:true})}>
                        {'清空'}
                      </Button>
                      <Button className={classes.textLink} startIcon={<ReplayIcon/>} onClick={()=>this.setState({showNotFinishedWrapper:true})}>
                        {'回復目前發佈頁面'}
                      </Button>
                      <Button className={classes.textLink} startIcon={<LibraryAddCheckIcon/>} onClick={this.publicTemp}>
                        {'發佈'}
                      </Button>
                    </div>
                    :
                    null
                  }      
                </Paper>
              </Grid>         
              <Grid item xs={12}>
                <Paper className={classes.fixedHeight}>
                  <StaticPageBody ref={this.staticPageBodyRef} userID={this.props.userID} editPage={this.editPage} sessionAvaliable={this.state.sessionInfo ? this.state.sessionInfo.sessionAvaliable : false }/>
                </Paper>
              </Grid>              
            </Grid>
          </Container>
        </main>
      )
    }
  }

export default withStyles(useStyles)(StaticPageManagementBody)